// Libraries
import { createNavigator, StackRouter } from '@react-navigation/core'
import I18n from 'i18next'
import { includes } from 'lodash'

// Utils
import { prepareStack } from 'Navigation/Utils'

// Layout
import { AuthenticatedLayout } from 'Navigation/Layout'

// Views
import Tanks from 'Views/Tanks'
import Scenarios from 'Views/Scenarios'
import Scenario from 'Views/Scenario'
import Sites from 'Views/Sites'
import Silos from 'Views/Silos'
import Basins from 'Views/Basins'

// Stacks
export const Stack = StackRouter(
  prepareStack({
    Basins: {
      screen: Basins,
      path: 'basins/:id?',
      navigationOptions: {
        title: I18n.t('pages.basins.title')
      }
    },
    Silos: {
      screen: Silos,
      path: 'silos/:id?',
      navigationOptions: {
        title: I18n.t('pages.silos.title')
      }
    },
    Tanks: {
      screen: Tanks,
      path: 'tanks/:id?',
      navigationOptions: {
        title: I18n.t('pages.tanks.title')
      }
    },
    Sites: {
      screen: Sites,
      path: 'sites/:id?',
      navigationOptions: {
        title: I18n.t('pages.sites.title')
      }
    },
    Scenarios: {
      screen: Scenarios,
      path: 'scenarios/:status?',
      navigationOptions: ({ navigation }) => {
        const whitelist = ['done', 'running']
        const status = navigation.getParam('status')

        // ContrÃ´le l'absence ou le passage d'un statut inconnu
        // Redirection automatique vers le statut `done`
        if (!includes(whitelist, status)) {
          navigation.navigate('Scenarios', { status: 'done' })
        }

        return {
          title: I18n.t(
            `pages.scenarios.${navigation.getParam('status')}.title`
          )
        }
      }
    },
    Scenario: {
      screen: Scenario,
      path: 'scenarios/:status?/:id',
      navigationOptions: ({ navigation }) => {
        const whitelist = ['done', 'running']
        const status = navigation.getParam('status')

        // ContrÃ´le l'absence ou le passage d'un statut inconnu
        // Redirection automatique vers le statut `done`
        if (!includes(whitelist, status)) {
          navigation.navigate('Scenarios', { status: 'done' })
        }

        return {
          title: I18n.t('pages.scenario.title')
        }
      }
    }
  }),
  {
    initialRouteName: 'Sites'
  }
)

// Navigators
const navigationConfig = {}
const Navigator = createNavigator(AuthenticatedLayout, Stack, navigationConfig)

export default Navigator
